import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { IconPicker } from '../IconPicker';

function ItemList({ items, set, selectedItem }) {
  const { t } = useTranslation();

  return (
    items?.length &&
    items?.map((element, i) => (
      <ListItem
        disablePadding
        key={`${element.text}${i}`}
        onClick={() => set(element)}
        sx={{
          display: 'block',
          backgroundColor: element?.label === selectedItem?.label ? '#24263C' : 'unset'
        }}
      >
        <ListItemButton
          sx={{
            color: 'white',
            minHeight: 28,
            justifyContent: 'initial',
            transition: 'opacity 0.2s ease-in-out',
            p: 0,
            ml: 2,
            ':hover': {
              opacity: '75%'
            }
          }}
        >
          <ListItemIcon
            sx={{
              color: 'white',
              minWidth: 0,
              mr: 0.5,
              justifyContent: 'center'
            }}
          >
            <IconPicker icon={element?.icon || element.association_type} />
          </ListItemIcon>
          <ListItemText
            primary={
              element?.id
                ? element?.icon
                  ? element.label
                  : element.association_type
                : t(element?.label)
            }
            sx={{
              opacity: 1,
              span: {
                fontWeight: '600 !important',
                fontSize: '14px !important',
                fontFamily: 'Mulish',
                textTransform: element?.id && !element?.icon ? 'uppercase' : null
              }
            }}
          />
        </ListItemButton>
      </ListItem>
    ))
  );
}

ItemList.propTypes = {
  items: PropTypes.array.isRequired,
  set: PropTypes.func.isRequired
};

export default ItemList;
